<template>
    <transition name="fade">
        <div v-if="show" class="fixed inset-0 z-[70] flex items-center justify-center bg-slate-950/45 px-6 backdrop-blur-[2px]">
            <div class="w-full max-w-2xl overflow-hidden rounded-[32px] border border-cyan-100/60 bg-white shadow-2xl">
                <div class="bg-[radial-gradient(circle_at_top_left,_rgba(236,254,255,0.95),_rgba(248,250,252,0.98)_45%,_rgba(255,255,255,1))] px-8 py-7">
                    <div class="flex flex-col gap-6 md:flex-row md:items-start">
                        <div class="flex h-16 w-16 shrink-0 items-center justify-center rounded-[24px] bg-white shadow-sm ring-1 ring-cyan-100">
                            <div class="relative h-9 w-9">
                                <div class="absolute inset-0 rounded-full border-4 border-cyan-100"></div>
                                <div class="absolute inset-0 animate-spin rounded-full border-4 border-transparent border-t-cyan-500 border-r-cyan-300"></div>
                            </div>
                        </div>

                        <div class="min-w-0 flex-1">
                            <div class="text-[11px] font-semibold uppercase tracking-[0.22em] text-cyan-600">Exportação de PDF</div>
                            <h2 class="mt-2 text-2xl font-bold text-slate-800">Montando o seu PDF</h2>
                            <p class="mt-2 text-sm leading-6 text-slate-500">
                                Estamos compilando o conteúdo editado, gráficos e dados clínicos em um documento PDF pronto para download.
                            </p>

                            <div class="mt-6 h-36 overflow-hidden rounded-[24px] border border-slate-100 bg-slate-950 px-5 py-5 text-sm text-slate-300 shadow-inner">
                                <div class="font-mono leading-7">
                                    {{ typedPhrase }}
                                    <span class="ml-0.5 inline-block h-5 w-[2px] animate-pulse bg-cyan-300 align-middle"></span>
                                </div>
                            </div>

                            <div class="mt-5 grid gap-3 sm:grid-cols-3">
                                <div class="rounded-2xl border border-slate-100 bg-white px-4 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
                                    Conteúdo editado
                                </div>
                                <div class="rounded-2xl border border-slate-100 bg-white px-4 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
                                    Gráficos clínicos
                                </div>
                                <div class="rounded-2xl border border-slate-100 bg-white px-4 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">
                                    Formatação PDF
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { ref, watch, onBeforeUnmount } from 'vue';

const PHRASES = [
    'Coletando o texto editado e separando seções clínicas do documento...',
    'Renderizando gráficos de perfil de risco e correlações biomecânicas...',
    'Aplicando formatação tipográfica profissional com identidade visual da clínica...',
    'Compondo cabeçalho, rodapé e dados demográficos do paciente...',
    'Convertendo conteúdo HTML em layout de página A4 com quebras otimizadas...',
    'Finalizando o PDF e preparando o download automático do arquivo...'
];

export default {
    name: 'PdfExportOverlay',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const typedPhrase = ref('');
        const phraseIndex = ref(0);

        let typingTimer = null;
        let holdTimer = null;

        function clearTimers() {
            if (typingTimer) {
                clearTimeout(typingTimer);
                typingTimer = null;
            }

            if (holdTimer) {
                clearTimeout(holdTimer);
                holdTimer = null;
            }
        }

        function typePhrase() {
            clearTimers();

            const phrase = PHRASES[phraseIndex.value % PHRASES.length];
            typedPhrase.value = '';

            const step = (charIndex = 0) => {
                typedPhrase.value = phrase.slice(0, charIndex);

                if (charIndex <= phrase.length) {
                    typingTimer = setTimeout(() => step(charIndex + 1), 24);
                    return;
                }

                holdTimer = setTimeout(() => {
                    phraseIndex.value = (phraseIndex.value + 1) % PHRASES.length;
                    typePhrase();
                }, 1300);
            };

            step(1);
        }

        watch(() => props.show, (visible) => {
            if (visible) {
                phraseIndex.value = 0;
                typePhrase();
                return;
            }

            clearTimers();
            typedPhrase.value = '';
        }, { immediate: true });

        onBeforeUnmount(() => {
            clearTimers();
        });

        return {
            typedPhrase
        };
    }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
